export const LOCALE: Record<string, string> = {
  SE: 'sv-SE',
  US: 'en-US'
};

export const successfulPaymentStatuses = ['authorized', 'confirmed', 'pendingsettle', 'settled'];
export const failedPaymentStatuses = ['authfailed', 'reversed', 'aborted', 'pendingreversal', 'nostate'];
export const pendingPaymentStatuses = ['authorizing'];
